import makeStyles from '@material-ui/core/styles/makeStyles';
import { ICheckoutTheme } from '../../../theme/ICheckoutTheme';
import { ButtonProps } from '@material-ui/core/Button';

export type ButtonWithIconClasses = 'root' | 'icon';

const GUTTER = 2;

const buttonWithIconStyles = makeStyles<ICheckoutTheme, ButtonProps & { iconSize: number }>(
  theme => ({
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: props => props.iconSize + 10,
      height: props => props.iconSize,
      position: 'relative',
      alignContent: 'center',
      display: 'flex',
      '&:hover span:last-child': {
        opacity: 0.96,
      },
    },
    icon: {
      display: 'block',
      position: 'absolute',
      top: GUTTER,
      right: GUTTER,
      height: props => props.iconSize - GUTTER * 2,
      width: props => props.iconSize - GUTTER * 2,
      background: theme.palette.primary.contrastText,
      borderRadius: '30px',
    },
  }),
  { name: 'Checkout_ButtonWithIcon' },
);

export default buttonWithIconStyles;
